<template>
  <Layout v-if="isAuthenticated" :key="customerId" v-model="customerId" @logout="logout">
    <RouterView />
  </Layout>
  <Notification />
</template>

<style>
/* Styling for the v-tooltip directive */
.p-tooltip {
  @apply bg-active-50 border border-slate-900 rounded-md max-w-60;
}
.p-tooltip-top {
  @apply mb-1;
}
.p-tooltip-right {
  @apply ml-1;
}
.p-tooltip-bottom {
  @apply mt-1;
}
.p-tooltip-left {
  @apply mr-1;
}
.p-tooltip-text {
  @apply text-gray-500 whitespace-normal text-left text-sm;
}
[data-pd-tooltip] {
  @apply underline decoration-dotted cursor-default relative underline-offset-2;
}
</style>

<script setup lang="ts">
import { RouterView, useRouter } from 'vue-router'
import Layout from '@/components/Layout.vue'
import Notification from '@/components/Notification.vue'
import { StorageSerializers, useStorage } from '@vueuse/core'
import { watch } from 'vue'
import { useAuth0 } from '@auth0/auth0-vue'
import { useQueryClient } from '@tanstack/vue-query'
import { identify } from './hubspot-chat-widget-loader'

const queryClient = useQueryClient()
const router = useRouter()

const { logout: auth0Logout, isAuthenticated, user } = useAuth0()
const logout = () =>
  auth0Logout({
    logoutParams: {
      returnTo: import.meta.env.VITE_AUTH0_CALLBACK_URL
    }
  })

const customerId = useStorage<number | undefined>('klimate-customer-id', undefined, undefined, {
  serializer: StorageSerializers.number
})
watch(customerId, async () => {
  // Company changes do not affect the signed-in user's profile.
  const invalidation = queryClient.invalidateQueries({
    predicate: (query) => query.queryKey[0] !== 'current-user'
  })

  if (router.currentRoute.value.name === 'strategy') {
    await router.replace({ name: 'strategy' })
  }

  await invalidation

  // Strategy defaults may settle while the new customer data is loading.
  if (
    router.currentRoute.value.name === 'strategy' &&
    Object.keys(router.currentRoute.value.query).length
  ) {
    await router.replace({ name: 'strategy' })
  }
})
watch(user, () => {
  // Identify user on hubspot by email address
  if (!user.value?.email) return
  identify(user.value.email, {
    last_platform_login: Date.now()
  })
})
</script>
